<script>
  import Page from '@components/page'
  import Button from '@components/buttons/button.svelte'
  import Block from '@components/general/block'
  import Form from '@components/forms'
  import Message from '@components/general/message.svelte'
  import { page, useForm } from '@inertiajs/svelte'
  import { Mail, ArrowLeft } from 'lucide-svelte'

  let user = $derived($page.props.user)

  let links = [{ text: "Settings", href: "/settings" }, { text: "Profile", href: "/settings/profile" }]

  const form = useForm({
    email_address: ''
  })

  function handleSubmit(e) {
    e.preventDefault()
    $form.post('/email_change')
  }

</script>

<Page.Layout title="Change email address">
  
  <Page.Navigation title="Change email address" Icon={Mail} {links} />
  
  <Page.Titles title="Change email address" subtitle="Enter your new email address">
    {#snippet buttons()}
      <Button path="/settings/profile" text="Back to profile" BeforeIcon={ArrowLeft} />
    {/snippet}
  </Page.Titles>
  
  <Page.Content>

    {#snippet main()}
      <Block.Element label="Email" title="Update your email address">
        <Form.Element {form} id="email-form" onsubmit={handleSubmit} class="my-3">
          <Form.Items>
            <Form.Item name="current_email_address" label="Current email address" type="email" disabled value={user.email_address} required inputClass="italic opacity-50" />
            <Form.Item name="email_address" label="New email address *" type="email" bind:value={$form.email_address} required autofocus />
          </Form.Items>
          <Message type="info" class="mt-6" message="Once submitted, you will receive a confirmation email to confirm the change. The new email address will not be active until you click the link in the email." />
          <Form.Submit class="mt-6" text="Request email change" loading={$form.processing} />
        </Form.Element>
      </Block.Element>

    {/snippet}

  </Page.Content>

</Page.Layout>
